export default __webpack_public_path__ + "static/media/qr-create-vc-uat.27b6d2b7.png";